class licenseConcepts {
  constructor(id, name, licTot) {
    this.id = id;
    this.name = name;
    this.licTot = licTot;
  }
  static fromJson({ conceptoId, nombre, licTot }) {
    return new licenseConcepts(conceptoId, nombre, licTot);
  }
}
export default licenseConcepts;
